import angular from "angular";

angular
    .module('app')
    .component('courseForm', {
        template: require('./course-form.html'),
        controller: ['$uibModal', '$http', '$timeout', 'ErrorResponseParser', 'Notifier', 'Upload', '$sce', controller],
        bindings: {
            course: '<',
            categories: '<',
            close: '&',
            dismiss: '&'
        }
    });

function controller($uibModal, $http, $timeout, ErrorResponseParser, Notifier, Upload, $sce) {


    let $ctrl = this;

    $ctrl.image = null;
    $ctrl.previewImage = null;
    $ctrl.selectedVideo = null;
    $ctrl.imageLoading = null;
    $ctrl.showVideLinkInputState = false;
    $ctrl.phoneMask = '+7 (999) 999-99-99';

    $ctrl.$onInit = function () {
        $ctrl.title = $ctrl.course.title;
        $ctrl.phone = $ctrl.course.phone ? $ctrl.course.phone.slice(1) : null;
        $ctrl.categoryId = $ctrl.course.category_id;
        $ctrl.description = $ctrl.course.description;
        $ctrl.imgUrl = $ctrl.course.imgUrl;
        $ctrl.previewImageUrl = $ctrl.course.preview_image_url;
        $ctrl.previewVideo = $ctrl.course.preview_video;
        $ctrl.openSingleSales = $ctrl.course.open_single_sales;
        $ctrl.singleSum = $ctrl.course.single_sum;
        $ctrl.oldSum = $ctrl.course.old_sum;
        $ctrl.vimeoVideoLink = $ctrl.course.vimeo_video_link;
        $ctrl.canOnlinePayment = $ctrl.course.can_online_payment;
        $ctrl.paymentInfo = $ctrl.course.payment_info;
        if ($ctrl.course.vimeo_video_html) {
            $ctrl.vimeoVideoHtml = $sce.trustAsHtml($ctrl.course.vimeo_video_html);
        } else {
            $ctrl.vimeoVideoHtml = null;
        }
    };

    $ctrl.submit = function () {

        $ctrl.loading = true;

        let params = {
            title: $ctrl.title,
            category_id: $ctrl.categoryId,
            phone: $ctrl.phone ? $ctrl.phone.replace(/\D/g, '') : null,
            description: $ctrl.description,
        };



        $http
            .put('/admin/courses/' + $ctrl.course.id, params)
            .then(
                function (response) {
                    $ctrl.loading = false;
                    $ctrl.course.title = $ctrl.title;
                    Notifier.success('Данные успешно обновлены', 2);
                },
                function (error) {
                    $ctrl.loading = false;
                    if (error.status == 422) {
                        $ctrl.validationErrors = error.data.errors;
                        Notifier.error('Ошибка при заполнении', 2);
                    } else {
                        Notifier.error(error.data.message || 'Undefined error', 2);
                    }
                }
            );

    };

    $ctrl.updateVideo = function () {

        if ($ctrl.vimeoVideoLink) {
            $ctrl.setVimeoVideoLink();
        }

        if ($ctrl.selectedVideo) {
            let params = {
                preview_video_id: $ctrl.selectedVideo.id
            };

            $http
                .put(`/admin/courses/${$ctrl.course.id}/set-preview-video`, params)
                .then(
                    function (response) {
                        $ctrl.previewVideo = $ctrl.selectedVideo;
                        $ctrl.vimeoVideoLink = null;
                        $ctrl.vimeoVideoHtml = null;
                        $ctrl.selectedVideo = null;
                        Notifier.success('Данные успешно обновлены', 2);
                    },
                    function (error) {
                        $ctrl.loading = false;
                        if (error.status == 422) {
                            $ctrl.validationErrors = error.data.errors;
                            Notifier.error('Ошибка при заполнении', 2);
                        }
                    }
                );
        }
    };

    $ctrl.uploadImage = function () {
        Notifier.success('Изображение загружается...', 0);
        $ctrl.imageLoading = true;
        Upload
            .upload({
                url: '/admin/courses/' + $ctrl.course.id + '/set-image',
                data: {
                    image: $ctrl.image
                },
            })
            .then(
                function (response) {
                    $ctrl.imageLoading = false;
                    Notifier.closeAll();
                    $ctrl.imgUrl = response.data[0];
                    $ctrl.image = null;
                    Notifier.success('Изображение успешно загружено', 2);
                },
                function (error) {
                    $ctrl.imageLoading = false;
                    Notifier.closeAll();
                    Notifier.error('Произошла ошибка', 2);
                },
                function (evt) {
                }
            );
    };

    $ctrl.uploadPreviewImage = function () {
        Upload
            .upload({
                url: '/admin/courses/' + $ctrl.course.id + '/set-preview-image',
                data: {
                    preview_image: $ctrl.previewImage
                },
            })
            .then(
                function (response) {
                    $ctrl.previewImageUrl = response.data.url;
                    $ctrl.previewImage = null;
                    Notifier.success('Изображение успешно загружена', 2);
                },
                function (error) {
                    Notifier.error('Произошла ошибка', 2);
                },
                function (evt) {
                }
            );

    };

    $ctrl.selectVideoModal = function () {
        $ctrl.showVimeoLinkInputState = false;
        $uibModal
            .open({
                component: 'videoSelectModal',
                size: 'lg',
                resolve : {
                    course: function () {
                        return $ctrl.course;
                    }
                }
            })
            .result
            .then(
                function (result) {
                    $ctrl.selectedVideo = result;
                },
                function () {
                }
            );
    };

    $ctrl.uploadImageModal = function () {
        $uibModal
            .open({
                component: 'uploadImage',
                size: 'lg',
                backdrop: 'static',
            })
            .result
            .then(function (result) {
                $ctrl.image = result;
            });
    };

    $ctrl.uploadVideoModal = function () {
        $uibModal
            .open({
                component: 'videosUploadModal',
                size: 'lg',
                resolve: {
                    uploadType: function () {
                        return 'single';
                    }
                }
            })
            .result
            .then(
                function (result) {
                    $ctrl.selectedVideo = result[0];
                },
                function () {
                }
            );
    };

    $ctrl.openVideoForm = function (video) {
        $uibModal
            .open({
                component: 'videoForm',
                size: 'lg',
                resolve: {
                    video: function () {
                        return video;
                    }
                }
            })
            .result
            .then(
                function (res) {

                },
                function (error) {

                }
            );
    };

    $ctrl.updateSingleSaleConfig = function () {
        $http
            .post(`/admin/courses/${$ctrl.course.id}/update-single-sales-config`, {
                open_single_sales: $ctrl.openSingleSales,
                single_sum: $ctrl.singleSum,
                old_sum: $ctrl.oldSum
            })
            .then(
                function (response) {
                    Notifier.success('Данные успешно обновились', 2);
                },
                function (error) {
                    Notifier.error('Произошла ошибка', 2);
                }
            );
    };

    $ctrl.openSingleSalesChanged = function () {
        if (!$ctrl.openSingleSales) {
            $ctrl.singleSum = null;
            $ctrl.oldSum = null;
        }
    };

    $ctrl.setVimeoVideoLink = function () {
        $ctrl.loading5 = true;
        $http
            .post(`/admin/courses/${$ctrl.course.id}/set-vimeo-video-link`, {
                link: $ctrl.vimeoVideoLink
            })
            .then(
                function (response) {
                    $ctrl.loading5 = false;
                    $ctrl.vimeoVideoHtml = $sce.trustAsHtml(response.data.html);
                    Notifier.success('Данные успешно обновлены', 2);
                },
                function (error) {
                    Notifier.error(error.data.message, 2);
                    $ctrl.loading5 = false;
                }
            );
    };

    // $ctrl.delVimeoVideoLink = function () {
    //
    //     if (!confirm('Вы действительно хотите удалить?')) {
    //         return;
    //     }
    //
    //     $http
    //         .post(`/admin/courses/${$ctrl.course.id}/del-vimeo-video-link`)
    //         .then(
    //             function (response) {
    //                 $ctrl.loading5 = false;
    //                 $ctrl.vimeoVideoLink = null;
    //                 $ctrl.vimeoVideoHtml = null;
    //             },
    //             function (error) {
    //                 $ctrl.loading5 = false;
    //             }
    //         );
    // };

    $ctrl.setPaymentInfo = function () {
        $ctrl.paymentLoading = true;
        $http
            .post(`/admin/courses/${$ctrl.course.id}/set-payment-info`, {
                can_online_payment: $ctrl.canOnlinePayment,
                payment_info: $ctrl.paymentInfo,
            })
            .then(
                function (response) {
                    $ctrl.paymentLoading = false;
                    Notifier.success('Данные успешно обновились', 2);
                },
                function (error) {
                    Notifier.error('Произошла ошибка', 2);
                    $ctrl.paymentLoading = false;
                }
            );
    };

    $ctrl.courseDeleteModal = function () {
        $uibModal
            .open({
                component: 'courseDeleteModal',
                size: 'md',
                resolve: {
                    course: function () {
                        return $ctrl.course;
                    }
                }
            })
            .result
            .then(
                function (res) {

                },
                function (error) {

                }
            );
    };

    $ctrl.courseQuitDraftMode = function () {
        $http
            .post(`/admin/courses/${$ctrl.course.id}/quit-draft-mode`)
            .then(
                function (response) {
                    Notifier.success('Выключаем режим черновика...', 2);
                    window.location = `/admin/courses/${$ctrl.course.id}/edit`;
                },
                function (error) {
                    Notifier.error(error.data.message, 200);
                }
            );
    };

    $ctrl.courseEnterDraftMode = function () {
        $http
            .post(`/admin/courses/${$ctrl.course.id}/enter-draft-mode`)
            .then(
                function (response) {
                    Notifier.success('Включаем режим черновика...', 2);
                    window.location = `/admin/courses/${$ctrl.course.id}/edit`;
                },
                function (error) {
                    Notifier.error(error.data.message, 200);
                }
            );
    };

    $ctrl.showVimeoLinkInput = function () {
        $ctrl.showVimeoLinkInputState = true;
        $ctrl.selectedVideo = null;
        $ctrl.previewVideo = null;
    }
}
